<template>
  <div v-if="display">
    <modal-layout-top :title="title" hideCloseButton class="with-buttons">
      <div class="field">
        <input id="active-project" type="checkbox" name="projectActive" v-model="proj.active" class="switch is-rounded" checked="checked">
        <label for="active-project" class="label">Aktiv</label>
      </div>
      <modal-layout-buttons :store-name="'projects'" />
    </modal-layout-top>

    <div class="content slider-modal">
      <div class="slider-modal-fields">

        <!-- <div class="field is-hidden-desktop">
          <input id="active-project" type="checkbox" name="projectActive" v-model="proj.active" class="switch is-rounded" checked="checked">
          <label for="active-project" class="label">Aktiv</label>
        </div> -->

        <div class="field">
          <label class="label">Ansvarig</label>
          <div class="select">
            <select v-model="proj.projectOwnerUserId" class="is-full-width">
              <option value="null" selected>Välj Ansvarig</option>
              <option v-for="user in users.items.filter(x => !x.deleted)" :key="user.userId" :value="user.userId">{{ user.firstName }} {{ user.lastName }} - {{ user.initials }}</option>
              <!--
              <optgroup v-if="users.items.some(x => x.deleted)" label="Borttagna">
                <option v-for="user in users.items.filter(x => x.deleted)" :key="user.userId" :value="user.userId">{{ user.firstName }} {{ user.lastName }} - {{ user.initials }}</option>
              </optgroup>-->
            </select>
          </div>
        </div>

        <div class="field">
          <label class="label">Granskare</label>
          <div class="select">
            <select v-model="proj.projectReviewerUserId">
              <option value="null" selected>Välj Granskare</option>
              <option v-for="user in users.items.filter(x => !x.deleted)" :key="user.userId" :value="user.userId">{{ user.firstName }} {{ user.lastName }} - {{ user.initials }}</option>
              <!--
              <optgroup v-if="users.items.some(x => x.deleted)" label="Borttagna">
                <option v-for="user in users.items.filter(x => x.deleted)" :key="user.userId" :value="user.userId">{{ user.firstName }} {{ user.lastName }} - {{ user.initials }}</option>
              </optgroup>-->
            </select>
          </div>
        </div>

        <div class="field">
          <label class="label">Kund *</label>
          <div class="is-flex">
            <!-- v-if="!isUpdate" -->
            <model-list-select
              class="is-inline-input"
              :list="customers"
              option-value="customerId"
              optionText="name"
              v-model="proj.customerId"
              placeholder="Välj kund">
            </model-list-select>
            <!--
            <div v-else class="is-inline-input">
              <input type="text" class="input" :value="customerName()" disabled>
            </div>
            -->
            <button class="button is-inline-button is-info" @click="openCustomerModal()" :disabled="isUpdate"><i class="fal fa-plus"></i></button>
          </div>
          <div v-show="errors.has('customerId')" class="invalid-feedback">{{ errors.first('customerId') }}</div>
        </div>

<!--
        <div class="field">
          <label class="label">Kund *</label>
          <model-list-select v-if="!isUpdate"
            :list="customers.items"
            option-value="customerId"
            optionText="name"
            v-model="proj.customerId"
            placeholder="Välj kund">
          </model-list-select>
          <div v-else class="is-inline-input">
            <input type="text" class="input" :value="customerName()" disabled>
          </div>
          <div v-show="errors.has('customerId')" class="invalid-feedback">{{ errors.first('customerId') }}</div>
        </div>
-->
        <div class="field">
          <label class="label">Adress till objekt</label>
          <div class="is-flex">
            <div class="select is-inline-input">
              <select v-model="proj.objectAddressId" @change="onChangeObjectAddress()">
                <option value="null" selected>Välj objektadress</option>
                <option v-for="address in customerAddressList.filter(x => x.addressType === 'Objekt')" :key="address.value" :value="address.value">{{ address.text }}</option>
              </select>
            </div>
            <button class="button is-inline-button is-info" @click="openAddressModal('Objekt')" :disabled="!proj.customerId"><i class="fal fa-plus"></i></button>
          </div>
        </div>

        <div class="field-full">
          <label class="label">Taggar</label>
          <multi-select
            :options="tagOptions"
            :selected-options="tags"
            placeholder="Välj taggar"
            @select="onSelectTag">
          </multi-select>
        </div>

        <div class="field">
          <h4>Kontakter</h4>
        </div>
        <div class="field"></div>

        <div class="field-full">
          <label class="label">Addresser</label>
          <div class="is-flex">
            <multi-select
              class="is-inline-input"
              :options="customerAddressList"
              :selected-options="proj.addresses"
              type="address"
              placeholder="Välj adresser"
              @select="onSelectAddress">
            </multi-select>
            <button class="button is-inline-button is-info" @click="openAddressModal(null)" :disabled="!proj.customerId"><i class="fal fa-plus"></i></button>
          </div>
        </div>

        <div class="field-full">
          <label class="label">Personer</label>
          <div class="is-flex">
            <multi-select
              class="is-inline-input"
              :options="contactList"
              :selected-options="proj.contacts"
              type="contact"
              placeholder="Välj kontakter"
              @select="onSelectContact">
            </multi-select>
            <button class="button is-inline-button is-info" @click="openContactModal(null)"><i class="fal fa-plus"></i></button>
          </div>
        </div>

        <div class="field">
          <h4>Ekonomi</h4>
        </div>
        <div class="field"></div>

        <div class="field">
          <label class="label">Beställare</label>
          <div class="is-flex">
            <div class="select is-inline-input">
              <select v-model="proj.mainContactId" @change="onChangeObjectAddress()">
                <option value="null" selected>Välj beställare</option>
                <option v-for="contact in proj.contacts" :key="contact.value" :value="contact.value">{{ contact.text }}</option>
              </select>
            </div>
            <button class="button is-inline-button is-info" @click="openContactModal('Beställare')"><i class="fal fa-plus"></i></button>
          </div>
        </div>

        <div class="field">
          <label class="label">Budget</label>
          <input class="input" type="number" v-model="proj.budget" />
        </div>

        <div class="field">
          <label class="label">E-post för fakturering</label>
          <input class="input" type="email" v-model="proj.invoiceEmail" />
        </div>

        <div class="field">
          <label class="label">Betalningsvillkor (dagar)</label>
          <input class="input" type="number" v-model="proj.paymentTermDays" />
        </div>

        <div class="field">
          <label class="label">Fakturaadress</label>
          <div class="is-flex">
            <div class="select is-inline-input">
              <select v-model="proj.invoiceAddressId" @change="onChangeInvoiceAddress()">
                <option value="null" selected>Välj fakturaadress</option>
                <option v-for="address in customerAddressList.filter(x => x.addressType === 'Fakturaadress')" :key="address.value" :value="address.value">{{ address.text }}</option>
              </select>
            </div>
            <button class="button is-inline-button is-info" @click="openAddressModal('Fakturaadress')" :disabled="!proj.customerId"><i class="fal fa-plus"></i></button>
          </div>
        </div>

        <div class="field">
          <label class="label">Fakturamärkning</label>
          <input class="input" type="text" v-model="proj.costCenter" />
        </div>

      </div>
      <div class="slider-modal-fields">
        <div class="field">
          <label class="label">Fakturarutin</label>
          <textarea class="textarea" v-model="proj.invoiceText"></textarea>
        </div>
        <div class="field">
          <label class="label">Fakturameddelande</label>
          <textarea class="textarea" v-model="proj.invoiceMessage" maxlength="160"></textarea>
        </div>
      </div>

      <div class="required-message">* obligatoriskt fält</div>

      <modal-layout-buttons :store-name="'projects'" />
      <template v-show="showDelete">
        <hr>
        <a class="is-pulled-right" @click="deleteProject">Radera projekt</a>
      </template>
    </div>
  </div>

</template>

<script>

import { mapActions, mapState } from 'vuex'
// import { MultiSelect } from 'vue-search-select'
import { MultiSelect } from '@/components/actions/MultiSelect'
import { BasicSelect, ListSelect, ModelListSelect } from 'vue-search-select'

import AddressModal from '@/components/modals/AddressModal'
import ContactModal from '@/components/modals/ContactModal'
import CustomerModal from '@/components/modals/CustomerModal'

import ModalLayoutTop from '@/components/modals/ModalLayoutTop'
import ModalLayoutButtons from '@/components/modals/ModalLayoutButtons'

export default {
  name: 'project-new-modal',
  watch: {
    'proj.customerId': function (newValue, oldValue) {
      this.customerChange()
    }
  },
  data () {
    return {
      proj: {
        customerId: 0,
        invoiceText: null,
        costCenter: null,
        invoiceEmail: null,
        projectOwnerUserId: null,
        projectReviewerUserId: null,
        mainContactId: null,
        invoiceAddressId: null,
        objectAddressId: null,
        contacts: [],
        addresses: [],
        active: true,
        budget: 0,
        paymentTermDays: 30
      },
      context: null,
      showDelete: false,
      submitted: false,
      tagSearchText: '',
      lastSelectTag: {},
      tagOptions: [],
      tags: [],
      isUpdate: Boolean,
      display: false,
      addressList: [],
      contactList: [],
      customerAddressList: [],
      customerId: null,
      customers: []
    }
  },

  components: {
    MultiSelect,
    ModelListSelect,
    ListSelect,
    BasicSelect,
    ModalLayoutTop,
    ModalLayoutButtons,
    AddressModal,
    ContactModal,
    CustomerModal
  },

  props: {
    id: {
      type: Number,
      required: false
    },
    callingRoute: {
      type: String,
      required: false
    }
  },

  computed: {
    ...mapState({
      projects: state => state.projects.all,
      // customers: state => state.customers.all,
      users: state => state.users.all,
      contacts: state => state.contacts.all,
      addresses: state => state.addresses.all
    }),

    allTags: function () {
      return this.projects.availableTags
    },

    title () {
      if (!this.id) {
        return 'Skapa nytt projekt'
      } else {
        return (
          'Redigera projekt ' + this.proj.projectCode
        )
      }
    }
  },

  methods: {

    ...mapActions(
      'projects', ['update', 'create', 'getById', 'getAllTags', 'addTagsToProject', 'delete']
    ),

    ...mapActions({
      'getAllUsers': 'users/getAll',
      'getAllAddresses': 'addresses/getAll',
      'getAllCustomers': 'customers/getAll',
      'getContacts': 'contacts/getListData',
      'getAllContacts': 'contacts/getAll',
      'getCustomerAddressesByProjectId': 'addresses/getCustomerAddressesByProjectId',
      'getAddressesByCustomerId': 'addresses/getAddressesByCustomerId'
    }),

    onChangeInvoiceAddress () {
      const address = this.customerAddressList.find(x => x.value === this.proj.invoiceAddressId)

      if (!this.proj.addresses.some(x => x.value === address.value)) {
        this.proj.addresses.push(address)
      }
    },

    onChangeObjectAddress () {
      const address = this.customerAddressList.find(x => x.value === this.proj.objectAddressId)

      if (!this.proj.addresses.some(x => x.value === address.value)) {
        this.proj.addresses.push(address)
      }
    },

    customerName () {
      return this.customers.find(x => x.customerId === this.proj.customerId).name
    },

    currentUserId: function () {
      return JSON.parse(localStorage.getItem('user')).userId
    },

    // Callbacks
    onSelectTag (tags, lastSelectTag) {
      this.tags = tags
      this.lastSelectTag = lastSelectTag
    },

    onSelectContact (contacts, lastSelected) {
      this.proj.contacts = contacts
    },

    onSelectAddress (addresses, lastSelected) {
      this.proj.addresses = addresses
    },

    closePanel () {
      this.$emit('closePanel')
    },

    saveTags () {
      let tags = this.tags.map(tag => ({ projectId: this.proj.projectId, tagId: tag.value }))
      this.addTagsToProject({ projectId: this.proj.projectId, tags: tags })
    },

    save () {
      this.submitted = true
      this.$validator.validateAll()

      if (this.proj.projectOwnerId === 'null') {
        this.proj.projectOwnerId = null
      }
      if (this.proj.projectReviewerId === 'null' || this.proj.projectReviewerId) {
        this.proj.projectOwnerId = null
      }

      if (this.id) {
        this.$store.dispatch(this.context + '/update', this.proj).then(response => {
          this.saveTags()
          // this.$emit('pageChange')
          this.$emit('closePanel')
        })
      } else {
        this.$store.dispatch(this.context + '/create', this.proj).then((response) => {
          this.proj.projectId = response.projectId
          this.saveTags()
          // this.$emit('pageChange')
          this.$emit('closePanel')
        })
      }
    },

    openCustomerModal () {
      this.$panel(CustomerModal, { }).then(response => {
        if (response && response.response) {
          const customer = response.response
          this.customerId = customer.customerId
          this.customers.push(customer)
          this.proj.customerId = customer.customerId
        }
      })
    },

    openAddressModal (addressType, addressId = null) {
      if (addressId) {
        this.$panel(AddressModal, { id: addressId }).then((response) => {
          if (response && response.response) {
            const address = response.response
            const addressDto = { value: address.addressId, text: this.getFormattedAddress(address), addressType: address.addressType }

            let projAddressIndex = this.proj.addresses.findIndex(x => x.value === address.addressId)
            if (projAddressIndex > -1) {
              this.proj.addresses[projAddressIndex].text = addressDto.text
              this.proj.addresses[projAddressIndex].value = addressDto.value
            }
          }
        })
      } else {
        this.$panel(AddressModal, { customerId: this.proj.customerId, addressType: addressType, preventListReload: true }).then(response => {
          if (response && response.response) {
            const address = response.response
            const addressDto = { value: address.addressId, text: this.getFormattedAddress(address), addressType: address.addressType }
            this.customerAddressList.push(addressDto)
            this.proj.addresses.push(addressDto)

            if (addressType === 'Objekt') {
              this.proj.objectAddressId = address.addressId
            } else if (addressType === 'Fakturaadress') {
              this.proj.invoiceAddressId = address.addressId
            } else {
              // alert(addressType)
            }
          }
        })
      }
    },

    openContactModal (role, contactId) {
      const customer = this.customers.find(x => x.customerId === this.proj.customerId)
      const customerName = customer ? customer.name : null

      if (contactId) {
        this.$panel(ContactModal, { id: contactId, customerName }).then(response => {
          if (response && response.response) {
            const contact = response.response

            // const contactDto = { value: contact.contactId, text: '(' + contact.contactId + ') ' + contact.fullName }
            const contactDto = this.getContactObject(contact)

            let projContactIndex = this.proj.contacts.findIndex(x => x.value === contact.contactId)
            if (projContactIndex > -1) {
              this.proj.contacts[projContactIndex].text = contactDto.text
              this.proj.contacts[projContactIndex].value = contactDto.value
              // this.proj.contacts[projContactIndex] = contactDto
            }
          }
        })
      } else {
        this.$panel(ContactModal, { role: role, customerName }).then(response => {
          if (response && response.response) {
            const contact = response.response

            // const contactDto = { value: contact.contactId, text: '(' + contact.contactId + ') ' + contact.fullName }
            const contactDto = this.getContactObject(contact)

            this.contactList.push(contactDto)
            this.proj.contacts.push(contactDto)

            if (role === 'Beställare') {
              this.proj.mainContactId = contact.contactId
            }
          }
        })
      }
    },

    async customerChange () {
      // Will be called on update before display is set to true
      if (!this.display) {
        return
      }

      if (!this.proj.customerId) {
        return
      }

      this.contacts.filter = {
        customerId: this.proj.customerId
      }

      this.addresses.filter = {
        customerId: this.proj.customerId
      }

      let promises = []
      promises.push(this.getAddressesByCustomerId(this.proj.customerId).then(addresses => {
        this.customerAddressList = addresses.map(address => ({ value: address.addressId, text: this.getFormattedAddress(address), addressType: address.addressType }))
      }))

      await Promise.all(promises)

      let customer = this.customers.find(x => x.customerId === this.proj.customerId)

      if (customer.mainAddressId) {
        let mainAddress = this.addressList.find(x => x.value === customer.mainAddressId)
        this.proj.addresses = [ mainAddress ]
        this.proj.invoiceAddressId = mainAddress.value
      }

      this.proj.invoiceText = customer.invoiceText
      this.proj.paymentTermDays = customer.paymentTermDays
      this.proj.invoiceEmail = customer.invoiceEmail
      this.proj.costCenter = customer.costCenter
    },

    deleteProject () {
      this.$confirm('Radera projekt', 'Är du säker på att du vill radera projeket ' + this.proj.projectCode + '?').then((result) => {
        if (result.value) {
          this.delete(this.proj.projectId)
          this.closePanel()
        }
      })
    },

    getFormattedAddress (address) {
      let parts = []

      if (address.name) {
        parts.push(address.name)
      }
      if (address.address1) {
        parts.push(address.address1)
      }
      if (address.address2) {
        parts.push(address.address2)
      }
      if (address.postalCode || address.city) {
        parts.push(address.postalCode + ' ' + address.city)
      }
      return parts.join(', ')
    },

    getContactObject (contact) {
      let text = contact.fullName

      if (contact.freeText) {
        text += ' (' + contact.freeText + ')'
      }

      return { value: contact.contactId, text }
    }
  },

  created () {
    if (this.$route.name === 'Home_ProjectOwner') {
      this.context = 'projectsOwner'
    } else if (this.$route.name === 'Home_ProjectReviewer') {
      this.context = 'projectsReviewer'
    } else {
      this.context = 'projects'
    }

    this.$on('emitSave', () => {
      this.save()
    })

    this.$on('emitMultiSelectModal', (payload) => {
      if (payload.type === 'address') {
        this.openAddressModal(null, payload.option.value)
      } else if (payload.type === 'contact') {
        this.openContactModal(null, payload.option.value)
      }
    })

    var promises = []

    // Get all customers for top dropdown
    promises.push(this.getAllCustomers().then(customers => {
      this.customers = customers
    }))

    // Get all addresses for top dropdown
    promises.push(this.getAllAddresses().then(addresses => {
      this.addressList = addresses.map(x => ({ value: x.addressId, text: x.formatted }))
    }))

    // Get all contacts for top dropdown
    promises.push(this.getAllContacts().then(contacts => {
      // this.contactList = contacts.map(x => ({ value: x.contactId, text: '(' + x.contactId + ') ' + x.fullName }))
      this.contactList = contacts.map(x => this.getContactObject(x))
    }))

    // Get all users for owner and reviewer
    promises.push(this.getAllUsers())

    // Get all tags for top dropdown
    promises.push(this.getAllTags().then((tags) => {
      this.tagOptions = tags.map(tag => ({ value: tag.tagId, text: tag.name }))
    }))

    if (this.id) {
      promises.push(this.getById(this.id).then(project => {
        this.proj = project
        this.tags = this.proj.tags.map(tag => ({ value: tag.tagId, text: tag.name }))
        this.isUpdate = true
      }))
      promises.push(this.getCustomerAddressesByProjectId(this.id).then(addresses => {
        this.customerAddressList = addresses.map(address => ({ value: address.addressId, text: this.getFormattedAddress(address), addressType: address.addressType }))
      }))
      let role = this.$store.state.auth.user.role
      if (role === 'SuperAdmin' || role === 'Developer') {
        this.showDelete = true
      }
    } else {
      if (this.callingRoute) {
        this.isUpdate = false
        if (this.$route.name === 'Home_ProjectOwner') {
          this.proj.projectOwnerUserId = this.currentUserId()
        } else if (this.$route.name === 'Home_ProjectReviewer') {
          this.proj.projectReviewerUserId = this.currentUserId()
        } else {
          this.proj.projectOwnerUserId = this.currentUserId()
          this.isUpdate = false
        }
      }
    }

    Promise.all(promises).then(x => {
      this.display = true
    }).catch(error => {
      console.error(error)
      this.$toast('Något gick fel, se konsolen', 'error')
    })
  }
}
</script>

<style scoped>
  .is-inline-input {
    flex-grow: 1;
  }
  .is-inline-button {
    text-align: right;
    margin-left: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/ProjectModal.vue